import { ChartColorType, Colors } from '@factorialco/deprecated-design-system'

const TOP_PERFORMER_THRESHOLD = 0.75
const LOW_PERFORMER_THRESHOLD = 0.25

export type ScoreScaleColor =
  | 'radicalRed1000'
  | 'radicalRed800'
  | 'radicalRed600'
  | 'radicalRed400'
  | 'radicalRed200'
  | 'viridian200'
  | 'viridian400'
  | 'viridian600'
  | 'viridian800'
  | 'viridian1000'

export const PERFORMANCE_COLORS: Record<'low' | 'top' | 'normal', ChartColorType> = {
  top: 'viridian1000',
  low: 'radicalRed1000',
  normal: 'viridian200',
}

export type ScoreCount = { id: number; score: number; count: number; color: Colors }

const scaleRange = (minScale: number, maxScale: number) => maxScale - minScale

const performanceThreshold = (minScale: number, maxScale: number, threshold: number) => {
  return threshold * scaleRange(minScale, maxScale) + minScale
}

export const isTopPerformer = (minScale: number, maxScale: number, score: number) => {
  const topScoreMin = performanceThreshold(minScale, maxScale, TOP_PERFORMER_THRESHOLD)
  return score <= maxScale && Math.round(score) >= topScoreMin
}

export const isLowPerformer = (minScale: number, maxScale: number, score: number) => {
  const lowScoreMax = performanceThreshold(minScale, maxScale, LOW_PERFORMER_THRESHOLD)
  return score >= minScale && Math.round(score) <= lowScoreMax
}

export const calculatePerformancePercentile = ({
  minScale,
  maxScale,
  data,
  total,
}: {
  minScale: number
  maxScale: number
  data: ScoreCount[]
  total: number
}) => {
  return data.reduce(
    (acc, { score, count }) => {
      if (isTopPerformer(minScale, maxScale, score)) {
        acc.top += (count / total) * 100
      }

      if (isLowPerformer(minScale, maxScale, score)) {
        acc.low += (count / total) * 100
      }

      return acc
    },
    { top: 0, low: 0 }
  )
}
